'use client';

import { Box } from '@mui/material';
import { MarketplaceBankingSubProductTypeEnum } from '@repo/supergraph/marketplace/enums';
import { useState } from 'react';
import { ProductNavItem } from './ProductNavItem';
import { PRODUCT_NAV_SECTION_MIN_HEIGHT_DESKTOP } from './constants';

type Props = {
  subProducts: MarketplaceBankingSubProductTypeEnum[];
};

export const ProductNav = ({ subProducts }: Props) => {
  const [activeAnchorId, setActiveAnchorId] = useState<string>('');

  return (
    <Box
      component="nav"
      aria-label="Product reviews navigation"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
        minHeight: { xs: 'auto', md: PRODUCT_NAV_SECTION_MIN_HEIGHT_DESKTOP },
      }}
    >
      {subProducts.map(subProduct => (
        <ProductNavItem
          key={subProduct}
          subProduct={subProduct}
          activeAnchorId={activeAnchorId}
          setActiveAnchorId={setActiveAnchorId}
        />
      ))}
    </Box>
  );
};
